import React, { useState } from 'react';
import './VehicleInspector.css';

const ZONES = [
    { id: 'av', label: 'Pare-chocs Avant', x: 50, y: 15 },
    { id: 'capot', label: 'Capot', x: 50, y: 30 },
    { id: 'pb', label: 'Pare-brise', x: 50, y: 45 },
    { id: 'toit', label: 'Toit', x: 50, y: 60 },
    { id: 'ar', label: 'Pare-chocs Arrière', x: 50, y: 90 },
    { id: 'coffre', label: 'Coffre', x: 50, y: 80 },
    { id: 'pg_av', label: 'Porte AV Gauche', x: 20, y: 55 },
    { id: 'pg_ar', label: 'Porte AR Gauche', x: 20, y: 75 },
    { id: 'pd_av', label: 'Porte AV Droite', x: 80, y: 55 },
    { id: 'pd_ar', label: 'Porte AR Droite', x: 80, y: 75 },
    { id: 'roue_av_g', label: 'Jante AV G', x: 15, y: 35 },
    { id: 'roue_ar_g', label: 'Jante AR G', x: 15, y: 85 },
    { id: 'roue_av_d', label: 'Jante AV D', x: 85, y: 35 },
    { id: 'roue_ar_d', label: 'Jante AR D', x: 85, y: 85 },
];

const VehicleInspector = ({ data, onChange, readOnly = false }) => {
    const [selectedZone, setSelectedZone] = useState(null);

    const toggleDefect = (zoneId) => {
        if (readOnly) return;
        const currentData = data || {};
        const isDefective = !!currentData[zoneId];

        onChange({
            ...currentData,
            [zoneId]: !isDefective
        });
    };

    return (
        <div className="vehicle-inspector-container">
            <div className="car-diagram">
                {/* Simplified Car Shape (Top View) */}
                <svg viewBox="0 0 100 120" className="car-svg">
                    <path
                        d="M30,10 Q50,5 70,10 L75,100 Q50,110 25,100 Z"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1"
                    />
                    {ZONES.map(zone => (
                        <circle
                            key={zone.id}
                            cx={zone.x}
                            cy={zone.y}
                            r="4"
                            className={`zone-marker ${(data && data[zone.id]) ? 'defective' : 'ok'}`}
                            onClick={() => toggleDefect(zone.id)}
                            onMouseEnter={() => setSelectedZone(zone.label)}
                            onMouseLeave={() => setSelectedZone(null)}
                        />
                    ))}
                </svg>
                <div className="inspector-tooltip">
                    {selectedZone || "Survolez ou cliquez sur une zone"}
                </div>
            </div>

            <div className="inspector-legend">
                <div className="legend-item"><span className="dot ok"></span> Sans défaut</div>
                <div className="legend-item"><span className="dot defective"></span> Défaut signalé</div>
            </div>

            {!readOnly && (
                <p className="inspector-hint">
                    Cliquez sur les points pour signaler une rayure, un impact ou un défaut existant.
                </p>
            )}
        </div>
    );
};

export default VehicleInspector;
